<div class="gw-flex gw-flex-col gw-gap-medium" [formGroup]="form">
  <div class="gw-flex gw-flex-col">
    <span class="gw-text-text-secondary gw-text-base gw-font-normal">
      {{ 'features.withdrawals.modalPix.transferTo' | translate }}
    </span>
    <span class="gw-text-text-primary gw-text-base gw-font-extrabold gw-mt-2">
      {{ resolvedRecipientName | uppercase }}
    </span>
  </div>

  <div class="gw-flex gw-flex-col gw-gap-small">
    <div
      [class.gw-pointer-events-none]="amountReadOnly"
      [class.gw-opacity-90]="amountReadOnly"
    >
      <gatewee-input-v2
        [id]="'withdrawal-pix-amount'"
        [form]="form"
        controlName="amount"
        type="currencyTaiga"
        [isLoading]="!amountInputReady"
        [hint]="amountFieldHint"
        [customMessages]="pixAmountCustomMessages"
        [label]="amountFieldLabelKey | translate"
        [readonly]="amountReadOnly"
        [placeholder]="
          'features.withdrawals.modalPix.amountPlaceholderExample' | translate
        "
      ></gatewee-input-v2>
    </div>

    <ng-container *ngIf="finalAmount !== null && finalAmount !== undefined">
      <div
        class="gw-h-px gw-w-full gw-bg-border-normal"
        aria-hidden="true"
      ></div>
      <gatewee-amount-fee-breakdown
        [amount]="amount"
        [calculatedFee]="calculatedFee"
        [finalAmount]="finalAmount"
        [inputMode]="amountInputMode"
        variant="compact"
      ></gatewee-amount-fee-breakdown>
    </ng-container>
  </div>

  <aside
    *ngIf="dailyRemainingHint"
    class="withdrawal-value-limits gw-flex gw-items-start gw-gap-small gw-rounded-lg gw-border-base-neutral gw-bg-background-elevation-1 gw-p-medium"
    aria-label="{{
      'features.withdrawals.modalPix.limits.sectionTitle' | translate
    }}"
  >
    <gatewee-icon
      icon="@phi.chart-line-up"
      iconStyle="primary"
      size="18px"
      class="gw-mt-2x-small gw-shrink-0 gw-text-text-secondary"
    ></gatewee-icon>
    <div class="gw-flex gw-min-w-0 gw-flex-col gw-gap-2x-small">
      <span class="gw-text-xs gw-font-semibold gw-text-text-secondary">
        {{ 'features.withdrawals.modalPix.limits.sectionTitle' | translate }}
      </span>
      <p class="gw-m-0 gw-text-sm gw-font-medium gw-text-text-primary">
        {{ dailyRemainingHint }}
      </p>
    </div>
  </aside>

  <gatewee-input-v2
    *ngIf="showHolderDocumentField"
    id="withdrawal-pix-holder-document"
    [form]="form"
    controlName="document"
    type="text"
    [required]="true"
    [label]="'features.withdrawals.modalPix.holderDocumentLabel' | translate"
    [placeholder]="
      'features.withdrawals.modalPix.holderDocumentPlaceholder' | translate
    "
    [mask]="holderDocumentMask"
    [max]="holderDocumentMaxLength"
    [customMessages]="holderDocumentCustomMessages"
    [hint]="{
      message: 'features.withdrawals.modalPix.holderDocumentHint' | translate,
      icon: '@phi.shield-check'
    }"
    (blur)="holderDocumentBlur.emit()"
  ></gatewee-input-v2>

  <div class="gw-flex gw-flex-col gw-gap-small">
    <label class="gw-form-label gw-m-0" for="withdrawal-pix-description">
      {{ 'features.withdrawals.modalPix.descriptionLabel' | translate }}
    </label>
    <textarea
      id="withdrawal-pix-description"
      class="gw-textarea-base placeholder:gw-text-text-tertiary gw-w-full"
      formControlName="description"
      rows="3"
      maxlength="140"
      [placeholder]="
        'features.withdrawals.modalPix.descriptionPlaceholder' | translate
      "
    ></textarea>
  </div>
</div>
